export interface ISettingsApp {
  MAX_MINUTE_REMOVE_BET: number;
  DEFAULT_DEPOSIT_AMOUNT: number;
  READED_SITE_NOTIFICATIONS_EXPIRE_IN: number;
}
export const SettingsApp: ISettingsApp = {
  MAX_MINUTE_REMOVE_BET: 60,
  DEFAULT_DEPOSIT_AMOUNT: 60,
  READED_SITE_NOTIFICATIONS_EXPIRE_IN: 28000000,
};
